module.exports = __webpack_public_path__ + "static/media/Shinbone.9383fefc.jpg";